export default __webpack_public_path__ + "static/media/fan_4_high.675df805.svg";